
import { defineComponent } from "vue";

import { CBtn } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn },
  mixins: [CBtn],
  props: {
    color: {
      type: String,
      default: "primary ltk-white--text",
    },
  },
});
